
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/quick-start.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-guide-quick-start-demo-xflow-guide"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/quick-start.en.md?type=demo')
};